var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-steam"},[_c('SteamKeys',_vm._g({attrs:{"contentOwnership":_vm.contentOwnership,"uploading":_vm.keysUploading},on:{"uploadGameKeys":_vm.uploadGameKeys}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }